import { getToken } from "../../../util/Cookies";
import axiosInstance from "../../../util/axiosInstance";

// ============================================
// PRIEST APIs
// ============================================

export const addPriestToCartAPI = async ({
  event_id,
  priest_id,
  service_id,
}) => {
  const token = getToken();
  console.log("got here for req", event_id);

  try {
    const response = await axiosInstance.post(
      "/cart/priest",
      {
        event_id,
        priest_id,
        service_id,
      },
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log("got error for api");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const addPriestPackageToCartAPI = async ({
  event_id,
  priest_id,
  service_id,
  package_id
}) => {
  try {
    const response = await axiosInstance.post("/cart/priestpackage", {
      event_id,
      priest_id,
      service_id,
      package_id
    });
    return response.data;
  } catch (error) {
    console.log("got error for api");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const deletePriestFromCartAPI = async (cartItemId) => {
  const token = getToken();

  try {
    const response = await axiosInstance.delete(`/cart/priest/${cartItemId}`, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    console.log("deletePriestFromCartAPI", response);
    return response.data;
  } catch (error) {
    console.log("got error for delete API");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const refundpreistfromcartapi = async (event_id, provider_id) => {
  try {
    const request = await axiosInstance.post("/cart/refundpriest", { event_id, provider_id });
    return request.data;
  } catch (error) {
    console.log("got error for refund ");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const getPriestToCartAPI = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/cart/priest", {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.log("got error for addEmptyPriestToCartAPI");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const fetchPriestOrdersAPI = async () => {
  try {
    const response = await axiosInstance.get("/orders/priest");
    return response.data;
  } catch (error) {
    console.error("priest Error in fetchPriestOrdersAPI:", error);
    return [];
  }
};

// ============================================
// TENTHOUSE APIs
// ============================================

export const addTentToCartAPI = async ({
  event_id,
  tent_provider_id,
  items,
}) => {
  try {
    const response = await axiosInstance.post("/cart/tent", {
      event_id,
      provider_id: tent_provider_id,
      items,
    });
    return response.data;
  } catch (error) {
    console.error("Error in addTentToCartAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const DirectaddTentToCartAPI = async (requestData) => {
  try {
    const response = await axiosInstance.post("/cart/tent", requestData);
    return response.data;
  } catch (error) {
    console.error("Error in addTentToCartAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const fetchTentCartAPI = async () => {
  try {
    const response = await axiosInstance.get("/cart/tent/grouped");
    return response.data;
  } catch (error) {
    console.error("tenthouse Error in fetchTentCartAPI:", error);
    return [];
  }
};

export const deleteTentCartItemAPI = async (event_id, provider_id) => {
  try {
    const response = await axiosInstance.delete("/cart/tent", {
      data: {
        event_id,
        provider_id
      }
    });
    console.log("Deleted TentCartItem:", response);
    return response.data;
  } catch (error) {
    console.error("Error in deleteTentCartItemAPI:", error);
    throw error;
  }
};

export const updateTentCartItemAPI = async (event_id, provider_id, items) => {
  try {
    console.log("response1", event_id, provider_id, items);
    const response = await axiosInstance.put("/cart/tent/item", {
      event_id,
      provider_id,
      items
    });
    console.log("Tent cart item updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating tent cart item:", error.response || error);
    throw error;
  }
};

export const getTentHouseProviderServicesAPI = async (provider_id) => {
  try {
    const response = await axiosInstance.get(`/tent-house/providers/${provider_id}/services`);
    return response.data;
  } catch (error) {
    console.error("Error in getTentHouseProviderServicesAPI:", error);
    throw error;
  }
};

export const refundtentproviderfromcartapi = async (event_id, provider_id) => {
  try {
    const request = await axiosInstance.post("/cart/refundtentprovider", { event_id, provider_id });
    return request.data;
  } catch (error) {
    console.log("got error for refund ");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const fetchTentOrdersAPI = async () => {
  try {
    const response = await axiosInstance.get("/orders/tent/grouped");
    return response.data;
  } catch (error) {
    console.error("tenthouse Error in fetchTentOrdersAPI:", error);
    return [];
  }
};

// ============================================
// CATERING APIs
// ============================================

export const addCateringToCartAPI = async ({
  event_id,
  provider_id,
  items,
}) => {
  try {
    const response = await axiosInstance.post("/cart/catering", {
      event_id,
      provider_id: provider_id,
      items,
    });
    return response.data;
  } catch (error) {
    console.error("Error in addCateringToCartAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const directaddCateringToCartAPI = async (requestData) => {
  try {
    const response = await axiosInstance.post("/cart/catering", requestData);
    return response.data;
  } catch (error) {
    console.error("Error in addCateringToCartAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const editCateringToCartAPI = async ({
  event_id,
  provider_id,
  items,
}) => {
  try {
    const response = await axiosInstance.put("/cart/catering", {
      event_id,
      provider_id: provider_id,
      items,
    });
    return response.data;
  } catch (error) {
    console.error("Error in addCateringToCartAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const fetchCateringCartAPI = async () => {
  try {
    const response = await axiosInstance.get("/cart/catering/grouped");
    return response;
  } catch (error) {
    console.error("catering Error in cateringfetchapi:", error);
    return { data: { data: [] } };
  }
};

export const deleteCateringCartItemAPI = async (event_id, provider_id) => {
  try {
    const response = await axiosInstance.delete("/cart/catering", {
      data: {
        event_id: event_id,
        provider_id: provider_id,
      },
    });
    console.log("Successfully deleted catering cart:", response);
    return response.data;
  } catch (error) {
    console.error("Error in deleteCateringCartItemAPI:", error);
    throw error;
  }
};

export const refundcateringfromcartapi = async (event_id, provider_id) => {
  try {
    const request = await axiosInstance.post("/cart/refundcateringprovider", { event_id, provider_id });
    return request.data;
  } catch (error) {
    console.log("got error for refund ");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

export const fetchCateringOrdersAPI = async () => {
  try {
    const response = await axiosInstance.get("/orders/catering/grouped");
    return response.data;
  } catch (error) {
    console.error("catering Error in fetchCateringOrdersAPI:", error);
    return [];
  }
};

// ============================================
// VENUE APIs
// ============================================

/**
 * Add venue to cart
 * POST /cart/venue
 */
export const addVenueToCartAPI = async (data) => {
  try {
    const response = await axiosInstance.post("/v1/cart/venue", data);
    return response.data;
  } catch (error) {
    console.error("Error in addVenueToCartAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

/**
 * Get venue cart items grouped by event
 * GET /cart/venue
 */
export const fetchVenueCartAPI = async () => {
  try {
    const response = await axiosInstance.get("/v1/cart/venue");
    return response.data;
  } catch (error) {
    console.error("venue Error in fetchVenueCartAPI:", error);
    return { success: false, data: [] };
  }
};

/**
 * Remove venue from cart
 * DELETE /cart/venue/:id
 */
export const deleteVenueCartItemAPI = async (cartItemId) => {
  try {
    const response = await axiosInstance.delete(`/v1/cart/venue/${cartItemId}`);
    console.log("Deleted VenueCartItem:", response);
    return response.data;
  } catch (error) {
    console.error("Error in deleteVenueCartItemAPI:", error);
    throw error;
  }
};

/**
 * Update venue cart item
 * PUT /cart/venue/:id
 */
export const updateVenueCartItemAPI = async (cartItemId, data) => {
  try {
    const response = await axiosInstance.put(`/v1/cart/venue/${cartItemId}`, data);
    console.log("Venue cart item updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating venue cart item:", error.response || error);
    throw error;
  }
};

/**
 * Refund venue from cart
 * POST /cart/refundvenue
 */
export const refundvenuefromcartapi = async (event_id, provider_id) => {
  try {
    const request = await axiosInstance.post("/v1/cart/refundvenue", { event_id, provider_id });
    return request.data;
  } catch (error) {
    console.log("got error for refund ");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

/**
 * Check venue availability
 * POST /venues/check-availability
 */
export const checkVenueAvailabilityAPI = async (data) => {
  try {
    const response = await axiosInstance.post("/v1/venues/check-availability", data);
    return response.data;
  } catch (error) {
    console.error("Error in checkVenueAvailabilityAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

/**
 * Get venue estimate
 * POST /venues/:venueId/estimate
 */
export const getVenueEstimateAPI = async (venueId, data) => {
  try {
    const response = await axiosInstance.post(`/v1/venues/${venueId}/estimate`, data);
    return response.data;
  } catch (error) {
    console.error("Error in getVenueEstimateAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

/**
 * Get venue booking rules
 * GET /venues/:venueId/booking-rules
 */
export const getVenueBookingRulesAPI = async (venueId) => {
  try {
    const response = await axiosInstance.get(`/v1/venues/${venueId}/booking-rules`);
    return response.data;
  } catch (error) {
    console.error("Error in getVenueBookingRulesAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

/**
 * Get venues by event
 * GET /venues/list-by-event/:eventId
 */
export const getVenuesByEventAPI = async (eventId, latitude, longitude) => {
  try {
    const params = {};
    if (latitude) params.latitude = latitude;
    if (longitude) params.longitude = longitude;
    
    const response = await axiosInstance.get(`/v1/venues/list-by-event/${eventId}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error in getVenuesByEventAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

/**
 * Get venues by filter
 * GET /venues/list-by-filter
 */
export const getVenuesByFilterAPI = async (params) => {
  try {
    const response = await axiosInstance.get("/v1/venues/list-by-filter", { params });
    return response.data;
  } catch (error) {
    console.error("Error in getVenuesByFilterAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

/**
 * Checkout venue cart item - creates Razorpay order
 * POST /cart/venue/:itemId/checkout
 */
export const checkoutVenueAPI = async (itemId, amount, coupon_code) => {
  try {
    const payload = { amount };
    if (coupon_code) payload.coupon_code = coupon_code;
    
    const response = await axiosInstance.post(`/v1/cart/venue/${itemId}/checkout`, payload);
    return response.data;
  } catch (error) {
    console.error("Error in checkoutVenueAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

/**
 * Verify venue payment
 * POST /cart/venue/:itemId/payments/verify
 */
export const verifyVenuePaymentAPI = async (itemId, paymentData) => {
  try {
    const response = await axiosInstance.post(`/v1/cart/venue/${itemId}/payments/verify`, paymentData);
    return response.data;
  } catch (error) {
    console.error("Error in verifyVenuePaymentAPI:", error);
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};

/**
 * Get venue orders
 * GET /orders/venue
 */
export const fetchVenueOrdersAPI = async () => {
  try {
    const response = await axiosInstance.get("/v1/orders/venue");
    return response.data;
  } catch (error) {
    console.error("venue Error in fetchVenueOrdersAPI:", error);
    return [];
  }
};

// ============================================
// FETCH CHECKOUT SUMMARY
// ============================================

export const fetchCheckoutSummaryApi = async (req) => {
  const token = getToken();
  console.log("got here for req", req);

  try {
    const response = await axiosInstance.post(
      "/payment-summary",
      req,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log("got error for api");
    if (error.response && error.response.data) {
      throw new Error(
        error.response.data.message || `HTTP error ${error.response.status}`
      );
    } else {
      throw new Error(error.message);
    }
  }
};